<template>
  <div class="cyber-wallet">
    <div class="cyber-wallet__card">
      <div class="cyber-wallet__glow-top"></div>
      <div class="cyber-wallet__header">
        <div class="cyber-wallet__icon">
          <i class="mdi mdi-wallet-outline"></i>
        </div>
        <h5 class="cyber-wallet__title">WALLET</h5>
      </div>

      <div class="cyber-wallet__balance">
        <span class="cyber-wallet__currency">$</span>
        <span class="cyber-wallet__amount count">{{ Number(regularWallet) }}</span>
        <span class="cyber-wallet__unit">USD</span>
      </div>

      <div class="cyber-wallet__stats">
        <div class="cyber-wallet__stat">
          <span class="cyber-wallet__stat-label">Total Earned</span>
          <span class="cyber-wallet__stat-value cyber-glow-text">${{ current_cap }} USD</span>
        </div>
        <div class="cyber-wallet__divider"></div>
        <div class="cyber-wallet__stat">
          <span class="cyber-wallet__stat-label">Maximum Cap</span>
          <span class="cyber-wallet__stat-value cyber-glow-text">${{ max_cap }} USD</span>
        </div>
      </div>
    </div>

    <div class="cyber-wallet__card cyber-wallet__card--secondary" v-if="activationWallet > 0">
      <div class="cyber-wallet__glow-top cyber-wallet__glow-top--cyan"></div>
      <div class="cyber-wallet__header">
        <div class="cyber-wallet__icon cyber-wallet__icon--cyan">
          <i class="mdi mdi-flash"></i>
        </div>
        <h5 class="cyber-wallet__title">ACTIVATION WALLET</h5>
      </div>
      <div class="cyber-wallet__balance">
        <span class="cyber-wallet__currency">$</span>
        <span class="cyber-wallet__amount count">{{ Number(activationWallet) }}</span>
        <span class="cyber-wallet__unit">USD</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cyber-wallet__card {
  background: linear-gradient(135deg, #252525, #2e2e2e);
  border: 1px solid #3d3d37;
  border-radius: 14px;
  padding: 0;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.cyber-wallet__card:hover {
  border-color: rgba(176, 154, 78, 0.3);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4), 0 0 20px rgba(176, 154, 78, 0.1);
}

.cyber-wallet__glow-top {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, #CDBA6E, #B09A4E, transparent);
}

.cyber-wallet__glow-top--cyan {
  background: linear-gradient(90deg, transparent, #7BBFB5, #00ffaa, #7BBFB5, transparent);
}

.cyber-wallet__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px 0;
}

.cyber-wallet__icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(176, 154, 78, 0.1);
  border: 1px solid rgba(176, 154, 78, 0.2);
  border-radius: 8px;
  color: #B09A4E;
  font-size: 1.2rem;
}

.cyber-wallet__icon--cyan {
  background: rgba(123, 191, 181, 0.1);
  border-color: rgba(123, 191, 181, 0.2);
  color: #7BBFB5;
}

.cyber-wallet__title {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.7rem !important;
  color: #9A998F !important;
  letter-spacing: 0.15em;
  margin: 0 !important;
}

.cyber-wallet__balance {
  padding: 15px 20px 5px;
  text-align: left;
}

.cyber-wallet__currency {
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  color: #B09A4E;
  vertical-align: top;
  margin-right: 2px;
}

.cyber-wallet__amount {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 2rem !important;
  font-weight: 700;
  color: #E0DFD8;
  text-shadow: 0 0 15px rgba(176, 154, 78, 0.2);
  line-height: 1;
}

.cyber-wallet__unit {
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.8rem;
  color: #9A998F;
  margin-left: 6px;
  vertical-align: bottom;
}

.cyber-wallet__stats {
  display: flex;
  padding: 15px 20px 18px;
  gap: 15px;
}

.cyber-wallet__stat {
  flex: 1;
}

.cyber-wallet__stat-label {
  display: block;
  font-size: 0.7rem;
  color: #6B6A62;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  font-family: 'Orbitron', sans-serif;
}

.cyber-wallet__stat-value {
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #7BC88F;
}

.cyber-glow-text {
  text-shadow: 0 0 8px rgba(123, 200, 143, 0.2);
}

.cyber-wallet__divider {
  width: 1px;
  background: linear-gradient(180deg, transparent, #3d3d37, transparent);
}
</style>

<script>
export default {
  name: "wallet",
  data() {
    return {
      current_cap: this.$store.getters.currentUser.vault.total_rewards,
      max_cap: this.$store.getters.currentUser.account_max_cap,
      activationWallet: this.$store.getters.currentUser.vault.comissions_amount,
      regularWallet: this.$store.getters.currentUser.vault.amount,
    };
  },
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      setTimeout(() => {
        $(".count").each(function () {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).text(),
              },
              {
                duration: 4000,
                easing: "swing",
                step: function (now) {
                  $(this).text(parseFloat(now).toFixed(2));
                },
              }
            );
        });
      }, 1000);
    },
  },
};
</script>
